/*
 * Well / Luxe department pages: hero slider counter, rail arrows and filter chips.
 * Every widget is plain scroll-snap; this file only adds the controls.
 */
(function () {
  function rtl() {
    return document.documentElement.dir === "rtl";
  }

  function scrollByPage(track, dir) {
    var step = track.clientWidth * (rtl() ? -dir : dir);
    track.scrollBy({ left: step, behavior: "smooth" });
  }

  function initHero(hero) {
    var track = hero.querySelector("[data-dept-track]");
    var slides = track ? track.children : [];
    var counter = hero.querySelector("[data-dept-counter]");
    var prev = hero.querySelector("[data-dept-prev]");
    var next = hero.querySelector("[data-dept-next]");
    if (!track || slides.length < 2) return;

    function pad(n) {
      return (n < 10 ? "0" : "") + n;
    }
    function index() {
      return Math.round(Math.abs(track.scrollLeft) / track.clientWidth);
    }
    function update() {
      var i = index();
      if (counter) {
        if (hero.getAttribute("data-counter") === "bar") counter.innerHTML = (i + 1) + ' <i aria-hidden="true">|</i> ' + slides.length;
        else counter.textContent = pad(i + 1) + " / " + pad(slides.length);
      }
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
    }
    if (prev) prev.addEventListener("click", function () { scrollByPage(track, -1); });
    if (next) next.addEventListener("click", function () { scrollByPage(track, 1); });
    track.addEventListener("scroll", function () { requestAnimationFrame(update); }, { passive: true });
    update();

    var delay = parseInt(hero.getAttribute("data-autoplay") || "0", 10) * 1000;
    if (delay > 0 && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      var paused = false;
      hero.addEventListener("pointerenter", function () { paused = true; });
      hero.addEventListener("pointerleave", function () { paused = false; });
      setInterval(function () {
        if (paused || document.hidden) return;
        if (index() >= slides.length - 1) track.scrollTo({ left: 0, behavior: "smooth" });
        else scrollByPage(track, 1);
      }, delay);
    }
  }

  function initRail(section) {
    var rail = section.querySelector("[data-dept-rail]");
    if (!rail) return;
    var prev = section.querySelector("[data-dept-prev]");
    var next = section.querySelector("[data-dept-next]");
    if (prev) prev.addEventListener("click", function () { scrollByPage(rail, -1); });
    if (next) next.addEventListener("click", function () { scrollByPage(rail, 1); });

    var chips = section.querySelectorAll("[data-dept-filter]");
    var items = rail.querySelectorAll("[data-dept-item]");
    var empty = section.querySelector("[data-dept-empty]");
    var more = section.querySelector("[data-dept-more]");
    chips.forEach(function (chip) {
      chip.addEventListener("click", function () {
        var value = chip.getAttribute("data-dept-filter");
        var key = chip.getAttribute("data-dept-key") || "vendor";
        var shown = 0;
        chips.forEach(function (c) {
          var on = c === chip;
          c.classList.toggle("is-active", on);
          c.setAttribute("aria-pressed", on ? "true" : "false");
        });
        items.forEach(function (item) {
          var values = (item.getAttribute("data-" + key) || "").split("|");
          var match = value === "*" || values.indexOf(value) > -1;
          item.hidden = !match;
          if (match) shown++;
        });
        if (empty) empty.hidden = shown > 0;
        if (more) {
          var href = chip.getAttribute("data-dept-href");
          if (href) more.setAttribute("href", href);
          var label = chip.getAttribute("data-dept-label");
          var labelEl = more.querySelector("[data-dept-more-label]");
          if (label && labelEl) labelEl.textContent = label;
        }
        rail.scrollTo({ left: 0 });
      });
    });
  }

  /* Paged grids (Luxe brands): one dot per screenful */
  function initPager(pager) {
    var track = pager.querySelector("[data-dept-pager-track]");
    var dots = pager.querySelector("[data-dept-dots]");
    if (!track || !dots) return;
    function pages() {
      return Math.max(1, Math.round(track.scrollWidth / track.clientWidth));
    }
    function build() {
      var n = pages();
      dots.innerHTML = "";
      dots.hidden = n < 2;
      for (var i = 0; i < n; i++) {
        var b = document.createElement("button");
        b.type = "button";
        b.setAttribute("aria-label", (i + 1) + " / " + n);
        (function (i) {
          b.addEventListener("click", function () {
            track.scrollTo({ left: (rtl() ? -1 : 1) * i * track.clientWidth, behavior: "smooth" });
          });
        })(i);
        dots.appendChild(b);
      }
      update();
    }
    function update() {
      var i = Math.round(Math.abs(track.scrollLeft) / track.clientWidth);
      Array.prototype.forEach.call(dots.children, function (d, j) {
        d.classList.toggle("is-active", j === i);
      });
    }
    track.addEventListener("scroll", function () { requestAnimationFrame(update); }, { passive: true });
    window.addEventListener("resize", build, { passive: true });
    build();
  }

  function init(scope) {
    scope.querySelectorAll("[data-dept-hero]").forEach(initHero);
    scope.querySelectorAll("[data-dept-pager]").forEach(initPager);
    scope.querySelectorAll("[data-dept-rail-section]").forEach(initRail);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { init(document); });
  else init(document);

  document.addEventListener("shopify:section:load", function (e) {
    init(e.target);
  });
})();
